import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=36e731ea&scoped=true&"
import script from "./departments.vue?vue&type=script&lang=js&"
export * from "./departments.vue?vue&type=script&lang=js&"
import style0 from "./departments.vue?vue&type=style&index=0&id=36e731ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e731ea",
  null
  
)

export default component.exports